import { env } from 'next-runtime-env';

export const auth = {
  clientId: env('NEXT_PUBLIC_AUTH_CLIENT_ID'),
  redirectUri: env('NEXT_PUBLIC_AUTH_REDIRECT_URI'),
  scope: 'openid',
  authorizationEndpoint: env('NEXT_PUBLIC_AUTH_ENDPOINT'),
  tokenEndpoint: env('NEXT_PUBLIC_AUTH_TOKEN_ENDPOINT'),
};
